import React, {useEffect, useState, Fragment} from 'react'
import Cookies from 'js-cookie'
import styled from 'styled-components'
import {    
    withStyles,
    CircularProgress,
    Typography,
    Card,
    Table,
    TableRow,
    TableHead,
    TableBody,
    TableCell,
    List,
    ListItem,
    ListItemText,
    ListItemIcon,
    Checkbox,
    Select,
    InputLabel,
    FormControl,
    MenuItem,    
    Divider,
} from '@material-ui/core'
import LineChart from '../charts/LineChart'
import MonthPicker from '../calendar/MonthPicker'
import { GiFastBackwardButton, GiFastForwardButton } from 'react-icons/gi'
import { Sync } from '@material-ui/icons'
import AskReport from '../AskReport'
import PageHeader from '../PageHeader'
import moment from 'moment'

const StyledTableHead = styled(TableHead)`
& .MuiTableCell-root {
    background-color: #6e6e6e;
}
`

const CustomCheckbox = withStyles({
    root: {
        '&$checked': {
            color: "#25aae1",
        }
    },
    checked: {},
})(props => <Checkbox color="default" {...props} />)

const CustomerRetention = (props) => {
    const {dark} = props
    const token = Cookies.get("token")
    const currentUser = JSON.parse(localStorage.getItem("currentUser")) ? JSON.parse(localStorage.getItem("currentUser")) : null
    const [custRetData, setCustRetData] = useState(null)
    const [custRetMarketData, setCustRetMarketData] = useState(null)
    const [markets, setMarkets] = useState([])    
    const [months, setMonths] = useState(moment().diff(moment("2014-01"), "months"))
    const [dates, setDates] = useState({minYearmo: moment("2014-01"), maxYearmo: moment()})
    const [checked, setChecked] = useState([])
    const [z11, setZ11] = useState(0)
    const [hasData, setHasData] = useState(true)

    const getCustData = () => {        
        const request = Promise.all([
            fetch(`https://api.v2.smartdash.com/smartdash-dev/v1/index.cfm/custRetention/market/monthly?min_yearmo=${dates.minYearmo.format("YYYY-MM")}&max_yearmo=${dates.maxYearmo.format("YYYY-MM")}`, {headers: {token: token}}),
            fetch(`https://api.v2.smartdash.com/smartdash-dev/v1/index.cfm/custRetention/location/monthly?min_yearmo=${dates.minYearmo.format("YYYY-MM")}&max_yearmo=${dates.maxYearmo.format("YYYY-MM")}`, {headers: {token: token}}),
        ])

        request.then(([response, response2]) => Promise.all([response.json(), response2.json()]))
        .then(([data, data2]) => {            
            if(data.length > 0) {
                setCustRetData(data2)
                setCustRetMarketData(data.filter(({Market}) => Market !== ""))
                setMarkets(data.filter(({Market}) => Market !== ""))
                setChecked(data.filter(({Market}) => Market !== "").map(({Market}) => Market))
            } else {
                setHasData(false)
                setCustRetData([])
                setCustRetMarketData([])
            }
        })
    }
    
    useEffect(() => getCustData(), [])

    const getLineData = (type) => {
        const data = [...custRetMarketData].filter(({Market}) => checked.includes(Market))
        let months = custRetData.map(({Data}) => Data.map(({YearMo}) => YearMo))[0]
        let series = [
            {name: "New Customers", data: [], values: ["Customers_New", `${type === "yoy" ? "Customers_New_LY" : "Sales_New"}`]}, 
            {name: "Returning Customers", data: [], values: ["Customers_Ret", `${type === "yoy" ? "Customers_Ret_LY" : "Sales_Ret"}`]}
        ]    
        const length = dates.maxYearmo.format("M") >= moment().format("M") ? data.map(({Data}) => Data.length)[0] - 1 : data.map(({Data}) => Data.length)[0]               

        for(let i = 0; i < series.length; i++) {
            for(let j = 0; j < length; j++) {                
                const obj = {}
                const firstVal = data.map(({Data}) => Data.map(item => item[series[i].values[0]])[j]).reduce((a,b) => a + b, 0)
                const secondVal = data.map(({Data}) => Data.map(item => item[series[i].values[1]])[j]).reduce((a,b) => a + b, 0)
                obj["y"] = type === "yoy" ? secondVal > 0 ? ((firstVal / secondVal - 1) * 100).toFixed(2) : null : firstVal > 0 ? (secondVal / firstVal).toFixed(2) : null
                obj["x"] = months[j]            

                series[i].data.push(obj)
            }

            for(let j = 0; j < series[0].data.length; j++) {
                if(series[i].data[j].y <= 100 && series[i].data[j].y !== null) {
                    for(let k = 0; k < j; k++) {
                        series[i].data[j].y = null
                    }
                    break
                } 
            }
        }
        
        return series
    }    

    const handleChangeDates = (value, valName) => {        
        const request = Promise.all([
            fetch(`https://api.v2.smartdash.com/smartdash-dev/v1/index.cfm/custRetention/market/monthly?min_yearmo=${valName === "minYearmo" ? value.format("YYYY-MM") : dates.minYearmo.format("YYYY-MM")}&max_yearmo=${valName === "maxYearmo" ? value.format("YYYY-MM") : dates.maxYearmo.format("YYYY-MM")}&z11=${z11}`, {headers: {token: token}}),
            fetch(`https://api.v2.smartdash.com/smartdash-dev/v1/index.cfm/custRetention/location/monthly?min_yearmo=${valName === "minYearmo" ? value.format("YYYY-MM") : dates.minYearmo.format("YYYY-MM")}&max_yearmo=${valName === "maxYearmo" ? value.format("YYYY-MM") : dates.maxYearmo.format("YYYY-MM")}&z11=${z11}`, {headers: {token: token}})
        ])
        
        request.then(([response, response2]) => Promise.all([response.json(), response2.json()]))
        .then(([data, data2]) => {            
            if(data.length > 0) {
                setCustRetMarketData(data.filter(({Market}) => Market !== ""))
                setCustRetData(data2)
                setDates(prevState => ({...prevState, [valName]: value}))

                if(valName === "minYearmo") setMonths(Math.floor(dates.maxYearmo.diff(value, "months")))
                else setMonths(Math.floor(value.diff(dates.minYearmo, "months")))
            } else {

            }
        })
        .catch(error => {
            console.log(error)
        })
    }

    const handleSliderChanges = values => {
        const request = Promise.all([
            fetch(`https://api.v2.smartdash.com/smartdash-dev/v1/index.cfm/custRetention/market/monthly?min_yearmo=${values[0]}&max_yearmo=${values[1]}`, {headers: {token: token}}),
            fetch(`https://api.v2.smartdash.com/smartdash-dev/v1/index.cfm/custRetention/location/monthly?min_yearmo=${values[0]}&max_yearmo=${values[1]}`, {headers: {token: token}})
        ])

        request.then(([response, response2]) => Promise.all([response.json(), response2.json()]))
        .then(([data, data2]) => {
            if(data.length > 0) {
                setCustRetMarketData(data.filter(({Market}) => Market !== ""))
                setCustRetData(data2)
                setDates({minYearmo: moment(values[0]), maxYearmo: moment(values[1])})
            }
        })
        .catch(error => {
            console.log(error)
        })
    }

    const handleToggleChecked = (e, market) => {        
        const currentIdx = checked.indexOf(market)
        const newChecked = [...checked]

        if(currentIdx === -1) newChecked.push(market)
        else newChecked.splice(currentIdx, 1)

        setChecked(newChecked)
    }

    const handleToggleCustomerDef = (e) => {
        const { value } = e.target

        const request = fetch(`https://api.v2.smartdash.com/smartdash-dev/v1/index.cfm/custRetention/market/monthly?min_yearmo=${dates.minYearmo.format("YYYY-MM")}&max_yearmo=${dates.maxYearmo.format("YYYY-MM")}&z11=${value}`, {headers: {token: token}})

        request.then((response => response.json()))
        .then(data => {
            setZ11(value)            
            setCustRetMarketData(data.filter(({Market}) => checked.includes(Market)))
            setChecked(data.filter(({Market}) => Market !== "" && checked.includes(Market)).map(({Market}) => Market))
            setMarkets(data.filter(({Market}) => Market !== ""))
        })
        .catch(error => {console.log(error)})
    }    

    const renderTableBody = (direction) => {
        const restrictedDate = moment().subtract(1, "months").format("YYYY-MM")
        const data = [...custRetMarketData].filter(({Market}) => checked.includes(Market))
        
        return (            
            <Fragment>
                {data.map(({Data, Key, Market}, i) => (
                    <TableRow key={Key} className="cust-ret-table-body">                    
                        <TableCell><Typography variant="caption" style={{color: `${dark ? "#fff" : "#6e6e6e"}`}}>{Market}</Typography></TableCell>
                        <TableCell align="right"><Typography variant="caption" style={{color: `${dark ? "#fff" : "#6e6e6e"}`}}>{(Data.filter(({Yearmo}) => Yearmo !== restrictedDate).map(item => item[`Customers_${direction}`][0]).reduce((a,b) => a + b, 0) / Data.filter(({Yearmo}) => Yearmo !== restrictedDate).map(({Customers}) => Customers).reduce((a,b) => a + b, 0) * 100).toFixed(2)}%</Typography></TableCell>
                        <TableCell align="right"><Typography variant="caption" style={{color: `${dark ? "#fff" : "#6e6e6e"}`}}>{(Data.filter(({Yearmo}) => Yearmo !== restrictedDate).map(item => item[`Customers_${direction}`][1]).reduce((a,b) => a + b, 0) / Data.filter(({Yearmo}) => Yearmo !== restrictedDate).map(({Customers}) => Customers).reduce((a,b) => a + b, 0) * 100).toFixed(2)}%</Typography></TableCell>
                        <TableCell align="right"><Typography variant="caption" style={{color: `${dark ? "#fff" : "#6e6e6e"}`}}>{(Data.filter(({Yearmo}) => Yearmo !== restrictedDate).map(item => item[`Customers_${direction}`][2]).reduce((a,b) => a + b, 0) / Data.filter(({Yearmo}) => Yearmo !== restrictedDate).map(({Customers}) => Customers).reduce((a,b) => a + b, 0) * 100).toFixed(2)}%</Typography></TableCell>
                        <TableCell align="right"><Typography variant="caption" style={{color: `${dark ? "#fff" : "#6e6e6e"}`}}>{(Data.filter(({Yearmo}) => Yearmo !== restrictedDate).map(item => item[`Customers_${direction}`][3]).reduce((a,b) => a + b, 0) / Data.filter(({Yearmo}) => Yearmo !== restrictedDate).map(({Customers}) => Customers).reduce((a,b) => a + b, 0) * 100).toFixed(2)}%</Typography></TableCell>
                        <TableCell align="right"><Typography variant="caption" style={{color: `${dark ? "#fff" : "#6e6e6e"}`}}>{(Data.filter(({Yearmo}) => Yearmo !== restrictedDate).map(item => item[`Customers_${direction}`][4]).reduce((a,b) => a + b, 0) / Data.filter(({Yearmo}) => Yearmo !== restrictedDate).map(({Customers}) => Customers).reduce((a,b) => a + b, 0) * 100).toFixed(2)}%</Typography></TableCell>
                        <TableCell align="right"><Typography variant="caption" style={{color: `${dark ? "#fff" : "#6e6e6e"}`}}>{(Data.filter(({Yearmo}) => Yearmo !== restrictedDate).map(item => item[`Customers_${direction}`][5]).reduce((a,b) => a + b, 0) / Data.filter(({Yearmo}) => Yearmo !== restrictedDate).map(({Customers}) => Customers).reduce((a,b) => a + b, 0) * 100).toFixed(2)}%</Typography></TableCell>
                        <TableCell align="right"><Typography variant="caption" style={{color: `${dark ? "#fff" : "#6e6e6e"}`}}>{(Data.filter(({Yearmo}) => Yearmo !== restrictedDate).map(item => item[`Customers_${direction}`][6]).reduce((a,b) => a + b, 0) / Data.filter(({Yearmo}) => Yearmo !== restrictedDate).map(({Customers}) => Customers).reduce((a,b) => a + b, 0) * 100).toFixed(2)}%</Typography></TableCell>
                        {direction === "Forwards" ? <TableCell align="right"><Typography variant="caption" style={{color: `${dark ? "#fff" : "#6e6e6e"}`}}>{(Data.filter(({Yearmo}) => Yearmo !== restrictedDate).map(item => item[`Customers_${direction}`][6]).reduce((a,b) => a + b, 0) / Data.filter(({Yearmo}) => Yearmo !== restrictedDate).map(({Customers}) => Customers).reduce((a,b) => a + b, 0) * 100).toFixed(2)}%</Typography></TableCell> : null}
                    </TableRow>
                ))}            
            </Fragment>
        )
    }
    
    if(!custRetMarketData) return <CircularProgress />
    if(currentUser[0].cust_retention_show !== 1 || !hasData) return <AskReport />
    
    return (
        <div id="cust-ret">
            <PageHeader details={{title: "CUSTOMER RETENTION", icon: <Sync />}} />            
            <div className={`definition ${dark ? "dk" : "lt"}`}>
                {z11 === 0 ?
                <Fragment>
                    <Typography variant="caption" style={{fontWeight: "bold"}}>Client Customer ID</Typography>
                    <Typography variant="caption">Uses available customerIDs as provided in the data feed</Typography>
                </Fragment>
                :
                <Fragment>
                    <Typography variant="caption" style={{fontWeight: "bold"}}>LS Household ID</Typography>
                    <Typography variant="caption">Uses available customer name, CASS-certified street address, and phone number to generate a unique ID for each household</Typography>
                </Fragment>
                }
            </div>

            <div style={{display: "flex"}}>
                <Card className={`graph ${dark ? "bg-dk" : "bg-lt"}`}>
                    <div style={{width: "50%"}}>
                        <LineChart
                            series={getLineData("yoy")}
                            title={["YOY CUSTOMER CHANGES", "left"]}
                            toolbar={false}
                            height={350}
                            colors={["#54c496","#ffb11f"]}
                            darkMode={dark}
                        />
                    </div>
                    <Divider orientation="vertical" style={{backgroundColor: `${dark ? "#fff" : "#6e6e6e"}`}}/>
                    <div style={{width: "50%"}}>
                        <LineChart 
                            series={getLineData("avg_ticket")}
                            title={["AVERAGE TICKET (BY MONTH)", "left"]}
                            toolbar={false}
                            height={350}
                            colors={["#54c496","#ffb11f"]}
                            darkMode={dark}
                        />
                    </div>
                </Card>

                <Card className={`filters ${dark ? "bg-dk dk" : "bg-lt lt"}`}>
                    <div style={{display: "flex", justifyContent: "space-between"}}>
                        <Typography variant="caption">MARKETS ({markets.length})</Typography>
                        <Typography variant="caption">{checked.length} selected</Typography>
                    </div>

                    <List className={`list ${dark ? "dk" : "lt"}`} dense={true}>
                        {markets.map(({Key, Market}) => (
                            <ListItem key={Key} dense button onClick={(e) => handleToggleChecked(e, Market)}>
                                <ListItemIcon>
                                    <CustomCheckbox 
                                        edge="start"
                                        disableRipple
                                        checked={checked.indexOf(Market) !== -1}
                                    />
                                </ListItemIcon>
                                <ListItemText><Typography variant="caption">{Market}</Typography></ListItemText>
                            </ListItem>
                        ))}
                    </List>
                    
                    <MonthPicker 
                        maxValue={dates.maxYearmo}
                        minValue={dates.minYearmo}
                        maxSliderValue={months}
                        handleDateRange={handleChangeDates}
                        handleSliderDateChange={handleSliderChanges}
                        darkMode={dark}
                    />
                    
                    <FormControl variant="outlined" className="form-control">
                        <InputLabel id={dark ? "cust-id-select" : "cust-id-select-lt"}>Customer Definition</InputLabel>
                        <Select
                            id="customer-definition"
                            labelId="cust-id-select"
                            value={z11}
                            label="Customer Definition"
                            onChange={handleToggleCustomerDef}
                        >
                            <MenuItem value={0}><Typography variant="caption" className={`${dark ? "dk" : "lt"}`}>Client Customer ID</Typography></MenuItem>
                            <MenuItem value={1}><Typography variant="caption" className={`${dark ? "dk" : "lt"}`}>LS Household ID</Typography></MenuItem>
                        </Select>
                    </FormControl>
                </Card>
            </div>

            <div className="backwards-forwards-group">                            
                <Card className={`backwards-forwards-table ${dark ?  "bg-dk" : "bg-lt"}`}>
                    <Table stickyHeader>
                        <TableHead>
                            <TableRow className="table-head" style={{background: "#eb8e05"}}>
                                <TableCell style={{backgroundColor: "#eb8e05"}} colSpan={8} align="center">
                                    <Typography variant="caption" style={{display: "inline-flex", alignItems: "center", fontWeight: "bold", color: "#fff"}}><GiFastBackwardButton style={{marginRight: "10px"}}/>BACKWARDS</Typography>
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell style={{background: `${dark ? "#6e6e6e" : "#fff"}`}}><Typography variant="caption" style={{fontWeight: 'bold', color: `${dark ? "#fff" : "#6e6e6e"}`}}>MARKET</Typography></TableCell>
                                <TableCell style={{background: `${dark ? "#6e6e6e" : "#fff"}`}} align="right"><Typography variant="caption" style={{fontWeight: 'bold', color: `${dark ? "#fff" : "#6e6e6e"}`}}>NEW TO FILE</Typography></TableCell>
                                <TableCell style={{background: `${dark ? "#6e6e6e" : "#fff"}`}} align="right"><Typography variant="caption" style={{fontWeight: 'bold', color: `${dark ? "#fff" : "#6e6e6e"}`}}>0-3 Months</Typography></TableCell>
                                <TableCell style={{background: `${dark ? "#6e6e6e" : "#fff"}`}} align="right"><Typography variant="caption" style={{fontWeight: 'bold', color: `${dark ? "#fff" : "#6e6e6e"}`}}>3-6 Months</Typography></TableCell>
                                <TableCell style={{background: `${dark ? "#6e6e6e" : "#fff"}`}} align="right"><Typography variant="caption" style={{fontWeight: 'bold', color: `${dark ? "#fff" : "#6e6e6e"}`}}>6-12 Months</Typography></TableCell>
                                <TableCell style={{background: `${dark ? "#6e6e6e" : "#fff"}`}} align="right"><Typography variant="caption" style={{fontWeight: 'bold', color: `${dark ? "#fff" : "#6e6e6e"}`}}>12-18 Months</Typography></TableCell>
                                <TableCell style={{background: `${dark ? "#6e6e6e" : "#fff"}`}} align="right"><Typography variant="caption" style={{fontWeight: 'bold', color: `${dark ? "#fff" : "#6e6e6e"}`}}>18-24 Months</Typography></TableCell>
                                <TableCell style={{background: `${dark ? "#6e6e6e" : "#fff"}`}} align="right"><Typography variant="caption" style={{fontWeight: 'bold', color: `${dark ? "#fff" : "#6e6e6e"}`}}>24+ Months</Typography></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {renderTableBody("Backwards")}
                        </TableBody>
                    </Table>
                </Card>

                <Card className={`backwards-forwards-table ${dark ? "bg-dk" : "bg-lt"}`} style={{marginLeft: "20px"}}>
                    <Table stickyHeader>
                        <TableHead>
                            <TableRow className="table-head" style={{background: "#eb8e05"}}>
                                <TableCell style={{background: "#eb8e05"}} colSpan={9} align="center">
                                    <Typography variant="caption" style={{display: "inline-flex", alignItems: "center", fontWeight: "bold", color: "#fff"}}>FORWARDS<GiFastForwardButton style={{marginLeft: "10px"}} /></Typography>
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell style={{background: `${dark ? "#6e6e6e" : "#fff"}`}}><Typography variant="caption" style={{fontWeight: 'bold', color: `${dark ? "#fff" : "#6e6e6e"}`}}>MARKET</Typography></TableCell>
                                <TableCell style={{background: `${dark ? "#6e6e6e" : "#fff"}`}} align="right"><Typography variant="caption" style={{fontWeight: 'bold', color: `${dark ? "#fff" : "#6e6e6e"}`}}>NEVER RETURNED</Typography></TableCell>
                                <TableCell style={{background: `${dark ? "#6e6e6e" : "#fff"}`}} align="right"><Typography variant="caption" style={{fontWeight: 'bold', color: `${dark ? "#fff" : "#6e6e6e"}`}}>0-3 Months</Typography></TableCell>
                                <TableCell style={{background: `${dark ? "#6e6e6e" : "#fff"}`}} align="right"><Typography variant="caption" style={{fontWeight: 'bold', color: `${dark ? "#fff" : "#6e6e6e"}`}}>3-6 Months</Typography></TableCell>
                                <TableCell style={{background: `${dark ? "#6e6e6e" : "#fff"}`}} align="right"><Typography variant="caption" style={{fontWeight: 'bold', color: `${dark ? "#fff" : "#6e6e6e"}`}}>6-12 Months</Typography></TableCell>
                                <TableCell style={{background: `${dark ? "#6e6e6e" : "#fff"}`}} align="right"><Typography variant="caption" style={{fontWeight: 'bold', color: `${dark ? "#fff" : "#6e6e6e"}`}}>12-18 Months</Typography></TableCell>
                                <TableCell style={{background: `${dark ? "#6e6e6e" : "#fff"}`}} align="right"><Typography variant="caption" style={{fontWeight: 'bold', color: `${dark ? "#fff" : "#6e6e6e"}`}}>18-24 Months</Typography></TableCell>
                                <TableCell style={{background: `${dark ? "#6e6e6e" : "#fff"}`}} align="right"><Typography variant="caption" style={{fontWeight: 'bold', color: `${dark ? "#fff" : "#6e6e6e"}`}}>24+ Months</Typography></TableCell>
                                <TableCell style={{background: `${dark ? "#6e6e6e" : "#fff"}`}} align="right"><Typography variant="caption" style={{fontWeight: 'bold', color: `${dark ? "#fff" : "#6e6e6e"}`}}>LTV</Typography></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {renderTableBody("Forwards")}
                        </TableBody>
                    </Table>
                </Card>
            </div>
        </div>
    )
}

export default CustomerRetention